import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatusBannerComponent } from '@mode/shared/ui';

@Component({
  selector: 'mode-publish-dataset-banner',
  standalone: true,
  imports: [CommonModule, StatusBannerComponent],
  templateUrl: './publish-dataset-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublishDatasetBannerComponent {
  @Input() fromReport = false;
  message =
    "This Dataset is published as a table in the data workspace. Changes to its structure or name will require manual updates to the table and may break content that's built on it.";
}
